module.exports = __webpack_public_path__ + "static/media/nam.f68f879f.png";